import { render, staticRenderFns } from "./AdminTeacherReview.vue?vue&type=template&id=746d0702&scoped=true&"
import script from "./AdminTeacherReview.vue?vue&type=script&lang=js&"
export * from "./AdminTeacherReview.vue?vue&type=script&lang=js&"
import style0 from "./AdminTeacherReview.vue?vue&type=style&index=0&id=746d0702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d0702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VDialog,VIcon,VRow,VSpacer})
